/** Single source of truth for whether the Ion surface should mount at all.
 *  Mirrors the old ChatLauncher/ChatPanel gating so who-sees-Ion is unchanged.
 *  Unlike the old ChatLauncher, this does NOT exclude /assistant: IonSurface
 *  is now the one always-mounted container that renders the full geometry
 *  there (AssistantPage just sets ionSurface='full'). */
export function isIonVisible({ pathname, access, ionHidden }) {
  if (ionHidden) return false
  if (!access || access.loading) return false
  if (pathname.startsWith('/admin')) return false
  return true
}
